import DatePickerRange from 'components/PeriodSelection/DatePickerRange';
import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';


export function EditSongAlternativeTitles(songSplitsDetail: any) {

    const [showtab, setShowTab] = useState(1);
    const [showSubtab, setShowSubTab] = useState(4);

    return (
        <>
            <div className='ws-12'>
                <div className="box-content" data-ng-show="alternativeTitlesDisplay">
                    <div className="form-horizontal form-condensed">

                        <div className="row-fluid">
                            <div className="table-responsive">
                                <div className="alert alert-info ng-hide" ng-show="altTitles.length &lt;= 0">
                                    No alternative titles available for this song.
                                </div>
                                <table className="table" ng-show="altTitles.length &gt; 0">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Type</th>
                                            <th>Language</th>
                                            <th>Non Roman Alphabet</th>
                                            <th>Operation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr ng-repeat="($index, altTitle) in altTitles" className="ng-scope">
                                            <td >
                                                10
                                            </td>
                                            <td >
                                                First Line of Text
                                            </td>
                                            <td >
                                                Abkhazian
                                            </td>

                                            <td >
                                                NO
                                            </td>

                                            <td>
                                                <button className="btn icon-btn primary btn-xs" ng-click="editAltTitle(altTitle)">
                                                    <i className="icon-edit-pencil"></i> Edit
                                                </button>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                                <div className="clearfix">

                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </>
    )

}